export default "__VITE_ASSET__D7g2taUq__"